"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatorDocsBuilder = exports.ValidatorsDocsBuilder = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

var categories_1 = require("./categories");

var ValidatorsDocsBuilder =
/** @class */
function () {
  function ValidatorsDocsBuilder() {
    this._data = {};
  }

  ValidatorsDocsBuilder.prototype.validator = function (id) {
    if (this._data[id]) {
      throw new Error(id + " is already present");
    }

    this._data[id] = this._buildNewDocs(id);
    return new ValidatorDocsBuilder(this._data[id]);
  };

  ValidatorsDocsBuilder.prototype.get = function (id) {
    if (this._data[id]) {
      return this._data[id];
    }

    return this._buildNewDocs(id);
  };

  ValidatorsDocsBuilder.prototype._buildNewDocs = function (id) {
    return {
      validatorId: id,
      category: categories_1.ValidatorCategory.Misc,
      subCategory: categories_1.ValidatorSubCategory.Misc,
      title: "Validates " + id,
      affected: [],
      examples: [],
      resolutions: [],
      resolutionExamples: [],
      externalLinks: []
    };
  };

  return ValidatorsDocsBuilder;
}();

exports.ValidatorsDocsBuilder = ValidatorsDocsBuilder;

var ValidatorDocsBuilder =
/** @class */
function () {
  function ValidatorDocsBuilder(data) {
    this._data = data;
  }

  ValidatorDocsBuilder.prototype.category = function (value) {
    this._data.category = value;
    return this;
  };

  ValidatorDocsBuilder.prototype.subCategory = function (value) {
    this._data.subCategory = value;
    return this;
  };

  ValidatorDocsBuilder.prototype.title = function (value) {
    this._data.title = value;
    return this;
  };

  ValidatorDocsBuilder.prototype.description = function (value) {
    this._data.description = value;
    return this;
  };

  ValidatorDocsBuilder.prototype.externalLink = function (value) {
    this._data.externalLinks.push(value);

    return this;
  };

  ValidatorDocsBuilder.prototype.example = function (value, language) {
    var script = this._massageScript(value, language);

    this._data.examples.push(script);

    return this;
  };

  ValidatorDocsBuilder.prototype.affected = function (value) {
    this._data.affected.push(value);

    return this;
  };

  ValidatorDocsBuilder.prototype.affectedAllWorkloads = function () {
    return this.affected('Deployment').affected('DaemonSet').affected('StatefulSet').affected('CronJob').affected('Job').affected('ReplicaSet').affected('Pod');
  };

  ValidatorDocsBuilder.prototype.resolution = function (value) {
    this._data.resolutions.push(value);

    return this;
  };

  ValidatorDocsBuilder.prototype.resolutionExample = function (value, language) {
    var script = this._massageScript(value, language);

    this._data.resolutionExamples.push(script);

    return this;
  };

  ValidatorDocsBuilder.prototype.resolutionAndExample = function (text, script, language) {
    this.resolution(text);
    this.resolutionExample(script, language);
    return this;
  };

  ValidatorDocsBuilder.prototype._massageScript = function (value, language) {
    var script = the_lodash_1.default.trim(value, "\n\r");
    return {
      language: language !== null && language !== void 0 ? language : 'yaml',
      script: script
    };
  };

  return ValidatorDocsBuilder;
}();

exports.ValidatorDocsBuilder = ValidatorDocsBuilder;